/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivClearanceApprovalControllerGetParamsGen,
  MrfiktivClearanceApprovalViewModelGen,
  MrfiktivCreateClearanceApprovalDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateClearanceApprovalDtoGen,
  MrfiktivUpdateClearanceApprovalStatusDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ClearanceApproval<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags clearance-approval
   * @name ClearanceApprovalControllerCreate
   * @summary (ClearanceApproval - CREATE) Create a Clearance Approval
   * @request POST:/partner/{partnerId}/clearance-approval
   * @secure
   * @response `201` `MrfiktivClearanceApprovalViewModelGen` The created clearance approval
   */
  clearanceApprovalControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateClearanceApprovalDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval
   * @name ClearanceApprovalControllerGet
   * @summary (ClearanceApproval - READ) Get all Clearance Approvals
   * @request GET:/partner/{partnerId}/clearance-approval
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivClearanceApprovalViewModelGen)[] })`
   */
  clearanceApprovalControllerGet = (
    { partnerId, ...query }: MrfiktivClearanceApprovalControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivClearanceApprovalViewModelGen[] }, any>({
      path: `/partner/${partnerId}/clearance-approval`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval
   * @name ClearanceApprovalControllerGetOne
   * @summary (ClearanceApproval - READ) Get a Clearance Approval
   * @request GET:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The clearance approval
   */
  clearanceApprovalControllerGetOne = (partnerId: string, clearanceApprovalId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval
   * @name ClearanceApprovalControllerUpdate
   * @summary (ClearanceApproval - UPDATE) Update a Clearance Approval
   * @request PATCH:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The updated clearance approval
   */
  clearanceApprovalControllerUpdate = (
    partnerId: string,
    clearanceApprovalId: string,
    data: MrfiktivUpdateClearanceApprovalDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval
   * @name ClearanceApprovalControllerDelete
   * @summary (ClearanceApproval - DELETE) Delete a Clearance Approval
   * @request DELETE:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The deleted clearance approval
   */
  clearanceApprovalControllerDelete = (partnerId: string, clearanceApprovalId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags clearance-approval
   * @name ClearanceApprovalControllerUpdateStatus
   * @summary (ClearanceApproval - UPDATE) Update status of a clearance approval
   * @request PATCH:/partner/{partnerId}/clearance-approval/{clearanceApprovalId}/status
   * @secure
   * @response `200` `MrfiktivClearanceApprovalViewModelGen` The updated clearance approval
   */
  clearanceApprovalControllerUpdateStatus = (
    partnerId: string,
    clearanceApprovalId: string,
    data: MrfiktivUpdateClearanceApprovalStatusDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivClearanceApprovalViewModelGen, any>({
      path: `/partner/${partnerId}/clearance-approval/${clearanceApprovalId}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
